import { getSeverity, getStatus, getCriticality } from '../../lib/design-tokens';

/**
 * SeverityBadge — Donkere tekst op lichte achtergrond
 */
export const SeverityBadge = ({ level, testId }) => {
  const sev = getSeverity(level);
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-semibold ${sev.badge}`} data-testid={testId || `severity-${level}`}>
      {sev.label}
    </span>
  );
};

/**
 * StatusBadge — Donkere tekst op lichte achtergrond
 */
export const StatusBadge = ({ status, testId }) => {
  const st = getStatus(status);
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-semibold border ${st.cls}`} data-testid={testId || `status-${status}`}>
      {st.label}
    </span>
  );
};

/**
 * CriticalityBadge
 */
export const CriticalityBadge = ({ level, testId }) => {
  const crit = getCriticality(level);
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-semibold ${crit.cls}`} data-testid={testId || `criticality-${level}`}>
      {crit.label}
    </span>
  );
};

/**
 * SeverityChip — Klikbaar filter-chip
 */
export const SeverityChip = ({ level, count, active, onClick }) => {
  const sev = getSeverity(level);
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-all border ${
        active
          ? `${sev.badge} ring-2 ring-offset-1 ring-current`
          : 'bg-white text-[#4B5563] border-[#E5E7EB] hover:border-[#D1D5DB]'
      }`}
      data-testid={`severity-chip-${level}`}
    >
      <span className={`h-2 w-2 rounded-full ${sev.dot}`} />
      {sev.label}
      <span className="text-[11px] font-bold opacity-70">{count}</span>
    </button>
  );
};

/**
 * AllChip — "Alle" filter chip
 */
export const AllChip = ({ count, active, onClick }) => (
  <button
    onClick={onClick}
    className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition-all border ${
      active ? 'bg-[#111827] text-white border-[#111827]' : 'bg-white text-[#4B5563] border-[#E5E7EB] hover:border-[#D1D5DB]'
    }`}
    data-testid="severity-chip-all"
  >
    Alle ({count})
  </button>
);
